import { routes as auth } from "./auth";
import { routes as home } from "./home";
import { routes as config } from "./config";
import { routes as errors } from "./errors";

export default [...auth, ...home, ...config, ...errors];
